/**
 * @hidden
 */
export var isPresent = function isPresent(value) {
  return value !== null && value !== undefined;
};
/**
 * @hidden
 */

export var isBlank = function isBlank(value) {
  return value === null || value === undefined;
};
/**
 * @hidden
 */

export var isArray = function isArray(value) {
  return Array.isArray(value);
};
/**
 * @hidden
 */

export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
/**
 * @hidden
 */

export var isString = function isString(value) {
  return typeof value === 'string';
};
/**
 * @hidden
 */

export var isTruthy = function isTruthy(value) {
  return !!value;
};
/**
 * @hidden
 */

export var isNullOrEmptyString = function isNullOrEmptyString(value) {
  return isBlank(value) || value.trim().length === 0;
};
/**
 * @hidden
 */

export var isNotNullOrEmptyString = function isNotNullOrEmptyString(value) {
  return !isNullOrEmptyString(value);
};
/**
 * @hidden
 */

export var isNumeric = function isNumeric(value) {
  return !isNaN(value - parseFloat(value));
};
/**
 * @hidden
 */

export var isDate = function isDate(value) {
  return value && value.getTime;
};